import { jsxs as p, jsx as r } from "react/jsx-runtime";
import * as l from "react";
import y, { memo as C, useRef as $ } from "react";
import { u as e } from "../../styled-components.browser.esm-BFmoFexH.js";
import { _ as B } from "../../lodash-DeBCDn4U.js";
import { IconContainer as E } from "@biron-data/react-components";
import { F } from "../../ChevronDownIcon-CUajCkYx.js";
import { NUMBER_OF_FILTER_PER_LINE as W } from "./BoxWrapper.constants.js";
import { useLanguageResolver as _ } from "@biron-data/react-contexts";
import k from "./box/Box.js";
import L from "./boxWithDescription/BoxWithDescription.js";
function j(o, t) {
  return /* @__PURE__ */ l.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, o), /* @__PURE__ */ l.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 15l7-7 7 7"
  }));
}
const I = l.forwardRef(j), N = 10, Z = C(function({
  filters: t = [],
  seeDescription: a,
  onFiltersChange: c,
  onFiltersDelete: n,
  numberOfFilterPerLine: s = W,
  isFilterLineFullSize: d,
  isEditable: f = !0,
  toggleFilterLine: h,
  onEdit: g,
  loadDictionaryEntries: x
}) {
  const u = _(), v = $();
  return /* @__PURE__ */ p(T, { children: [
    /* @__PURE__ */ r("div", { children: /* @__PURE__ */ p(D, { onClick: () => h(), children: [
      /* @__PURE__ */ r(m, { children: `${u.get("configuration-label-filters")}` }),
      " ",
      /* @__PURE__ */ p(M, { children: [
        "(",
        t.length,
        ")"
      ] }),
      /* @__PURE__ */ r(E, { color: "var(--light-grey)", size: 16, children: d ? /* @__PURE__ */ r(I, {}) : /* @__PURE__ */ r(F, {}) })
    ] }) }),
    d && /* @__PURE__ */ r(S, { children: /* @__PURE__ */ r(P, { children: /* @__PURE__ */ r(O, { ref: v, children: t.map((w, i) => {
      const R = /* @__PURE__ */ r(
        a ? L : k,
        {
          filter: w,
          isEditable: f,
          close: () => n(i),
          handleFilterChange: (b) => c(b, i),
          onEdit: g,
          loadDictionaryEntries: x
        },
        i
      );
      return /* @__PURE__ */ r(U, { $nb: s, children: /* @__PURE__ */ r(y.Fragment, { children: R }, i) }, i);
    }) }) }) })
  ] });
}), D = e.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 5px;
  padding-right: 17px;
  padding-left: 10px;
  &:hover {
    color: var(--primary) !important;
    svg {
      color: var(--primary) !important;
    }
  }
`, m = e.span`
  overflow: hidden;
  white-space: nowrap;
`, M = e(m)`
  font-weight: bold;
  color: var(--primary);
`, P = e.div`
  margin-left: 12px;
  margin-right: 12px;
`, S = e.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`, T = e.div`
  display: flex;
  background-color: var(--main-background-color);
  padding-left: 10px;
  padding-right: 10px;
`, O = e.div`
  display: flex;
  gap: ${N}px;
  width: 100%;
  overflow-x: auto;
  padding-top: 10px;
  padding-bottom: 5px;
  margin-bottom: 5px;
`, U = e.div`
    flex: 0 0 calc(${({ $nb: o }) => 100 / o}%);
    max-width: calc(${({ $nb: o }) => 100 / o}%);
  
  ${(o) => {
  const t = [1550, 1250, 950, 750];
  return B.compact(t.map((a, c) => {
    const n = o.$nb - (c + 1);
    if (n > 0)
      return `@media (max-width: ${a}px) {
              flex: 0 0 calc(${100 / n}% );
              max-width: calc(${100 / n}%);
          }`;
  })).join("");
}}
`;
export {
  Z as default
};
//# sourceMappingURL=BoxesWrapperWithResume.js.map
